import { checkIfCompatibleWithBackend } from "@todesktop/client-util";
import { releaseMemory } from "./invoke.js";
/**
 * Extract the memory references from the given ToDesktop Ref object and tell
 * the main process to release them.
 */
export async function releaseMemoryBindings(ref) {
    return releaseMemory(ref.memoryRefs);
}
/**
 * Retrieve an object reference from the main process.
 */
export async function retrieve({ id, }) {
    if (checkIfCompatibleWithBackend(`${API_NAME}:retrieve`, "4.18.0")) {
        return window["todesktop"][API_NAME]({
            action: "retrieve",
            payload: { id },
        });
    }
}
/**
 * Subscribe to an event.
 *
 * @param event - The name of the event to subscribe to.
 * @param callback - The function to be invoked when this event is triggered.
 * @returns A callback for unsubscribing from the event.
 * @public
 */
export async function on(event, callback) {
    if (checkIfCompatibleWithBackend(`${API_NAME}:on`, "4.40.0")) {
        return window["todesktop"][API_NAME]({
            action: "on",
            payload: { event, onMessage: callback },
        });
    }
}
const API_NAME = "objectStore";
